<script>
import Gen from '@helper/Gen.js';
import env from '../../env.js';

export default {
	props: ['name', 'value', 'config'],
	computed:{
		page(){ return this.$root.page },
	},
	mounted: function () {
		Gen.readyPlugin("CKEDITOR", ()=>{
			this.init()
		})
	},
	methods:{
		init(){
			this.ck = global.CKEDITOR.replace(this.name, Object.assign({
				height: '300px',
				toolbar: [
					{ name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
					{ name: 'document', items: ['Save', 'NewPage', 'Preview', 'Print', '-', 'Templates'] },
					{ name: 'forms', items: ['Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField'] },
					{ name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
					{ name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language'] },
					'/',
					{ name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
					{ name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
					{ name: 'insert', items: ['Image', 'oembed', 'Table', 'HorizontalRule', 'SpecialChar', 'Iframe'] },
					{ name: 'colors', items: ['TextColor', 'BGColor'] },
					{ name: 'tools', items: ['Maximize', 'ShowBlocks', 'Source'] },
					// { name: 'others', items: ['-'] }
				],
				extraPlugins: ['oembed','embedsemantic','imagebrowser'],
				allowedContent: true,
				embed_provider: '//noembed.com/embed?url={url}&callback={callback}',
				// filebrowserUploadUrl: env.baseUrl+'/ajax/upload?pageType=editor',
			}, this.config || {}))
			this.ck.on('change', () => {
				this.$emit('input', this.ck.getData())
				this.onEdit = true
				this.$el.value = this.ck.getData()
				Gen.delay(() => {
					this.onEdit = false
					$(this.$el).valid()
				}, 300)
			})
			setTimeout(()=>{ 
				if(this.value){
					this.$el.value = this.value
					this.ck.setData(this.value)
				}
			}, 300)
		}
	},
	watch: {
		value: function (v) {
			if(!v) this.ck.setData("")
			if (!this.onEdit){
				if(this.ck) this.ck.setData(v)
			}
		}
	}
}
</script>

<template>
  <textarea :name="name" :id="name"></textarea>
</template>